import { createStore } from 'vuex';
import { Resources } from '@/store/modules/resources';
import { ExplorerMap } from '@/store/modules/map';
import { Details } from '@/store/modules/details';
import { Identify } from '@/store/modules/identify';
import { TimeTool } from '@/store/modules/time-tool';
import { DetailsMap } from '@/store/modules/layer-details-map';
export const store = createStore({
    state: {
        version: '2.0',
        root: true,
    },
    modules: {
        Resources,
        Map: ExplorerMap,
        Details,
        Identify,
        DetailsMap,
        TimeTool,
    },
});
